// import { createMedia } from '@artsy/fresnel'
import React, { useState, useEffect } from 'react'
import { withAuthenticator, Button, Heading, Text, TextField, View } from '@aws-amplify/ui-react';
import {Link} from "react-router-dom"
import { Storage } from "@aws-amplify/storage"
import styled from "styled-components";

function Manage({ signOut, user }) {

    const [projlist, setProjlist] = useState([])
    console.log("user", user.attributes.email)
    

    useEffect(() => {
      callList()
    }, [])
    

    async function siteOut () {
        const out = await signOut({ global: true })
        console.log("out", out)
        console.log("window.location", window.location)

        setTimeout(function() {
            if ( window.location.hostname === 'localhost' ) {
                window.location.href='http://localhost:3000';
            } else if ( window.location.hostname === 'quickpoly' ) {
                window.location.href='https://quickpoly.com';
            }
        }, 100);
    }

    async function callList () {

      const list = await Storage.list('', { level: "private" })
      .then (result => {return result }) // {key: "test.txt"}
      .catch(err => console.log(err));

      // console.log("list", list)

      let filteredList = []

      list.results.forEach((res)=>{
        if(res.key.split("/")[1] === "code"){
          let tempName = ""
          tempName = res.key.split("/")[2];
          tempName = tempName.split(".")[0]
          filteredList.push(tempName)
        }
      })

      // console.log("filteredList", filteredList)

      setProjlist(filteredList)

      // const list = await Storage.list('photos/', { level: 'private',identityId: '2bccebf1-0763-4b49-b186-a71190c47ab0' })
      // .then(({ results }) => console.log(results))
      // .catch((err) => console.log(err));

      // const downloadCode = async () => {

      //   const down = await Storage.get(projectname + ".py", { 
      //       level: 'private'
      //   });
    
      //   console.log("down",down)
      
      //   const downCode = await axios.get(down)
      //   console.log("downCode",downCode.data)
      //   setCode(downCode.data)
      // }
    
    }

  return (
    <>
    <nav className="bg-white border-gray-900 px-2 sm:px-4 py-2.5 dark:bg-gray-900">
        <div className="flex flex-wrap items-center justify-between mx-auto">
          <a href="https://flowbite.com/" className="flex items-center">
              <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white">QuickPloy</span>
          </a>
          <div class="flex md:order-2">
            <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" style={{marginLeft:"20px"}} onClick={siteOut}>로그오프</button>
              <button data-collapse-toggle="navbar-cta" type="button" class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-cta" aria-expanded="false">
                <span class="sr-only">Open main menu</span>
                <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
            </button>
          </div>
        </div>
      </nav>


      <div style={{marginTop:"100px", textAlign:"center", fontSize:"20px", fontWeight:"900"}}>
        내 작업실
        { projlist.length === 0 ?
        <></>
        :
        <>
        <div style={{marginTop:"20px"}}>
          <Link to="/addfunction">
          <button class="bg-transparent text-sm hover:bg-black text-black font-semibold hover:text-white py-1 px-2 border border-black hover:border-transparent rounded">
                  + 추가
                  {/* <svg aria-hidden="true" class="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> */}
              </button>
          </Link>
        </div>
        </>
      }
        <div style={{marginTop:"50px"}}></div>
        
        { projlist.length === 0 ?
          <div style={{width:"90%", margin:"0px auto", gap:"20px", display:"flex", flexDirection:"row", flexWrap:"wrap", justifyContent:"center"}}>
          <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-400">
              <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" style={{marginBottom:"30px"}}>배포된 기능이 없습니다.</h5>
              <Link to="/addfunction">
                <div class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-black rounded-lg dark:bg-white dark:hover:bg-black">
                      만들러가기
                      <svg aria-hidden="true" class="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                  </div>
              </Link>
          </div>
          </div> :
          <div style={{width:"90%", margin:"0px auto", gap:"20px", display:"flex", flexDirection:"row", flexWrap:"wrap", justifyContent:"center"}}>
            {
              projlist.map((res) =>                 
                  <div class="p-6 bg-white border border-gray-900 rounded-lg shadow dark:bg-white" style={{width:"300px"}}>
                    <div class="flex flex-wrap text-center mb-1">
                      <div class="mr-2 mb-2 rounded-full px-3 py-1 text-xs bg-blue-200 text-blue-800">Python</div>
                      <div class="mr-2 mb-2 rounded-full px-3 py-1 text-xs bg-blue-200 text-blue-800">주기적 실행 : 1분</div>
                    </div>
                    <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-500 dark:text-black" style={{marginBottom:"30px", textAlign:"left"}}>{res}</h5>
                    <Link to={`/editor/${res}`}>
                    <Buttonb>
                      수정하기
                    </Buttonb>

                        {/* <div style={{float:"left"}} class="inline-flex items-center px-3 py-2 text-sm font-bold text-center text-white bg-blue-700 rounded-lg">
                            상세
                            <svg aria-hidden="true" class="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        </div> */}
                    </Link>
                  </div>                
              )
            }
          </div>
        }



        <div style={{marginTop:"50px"}}></div>

        



      </div>
    </>
  );
}

const Buttonb = styled.button`
    height: 50px;
    color: white;
    background-color: black;
    border-radius: 8px;
    font-size: 14px;
    width: 100%;
    border: none;
    font-weight: 700;

    &:hover {
      background-color: gray;
    }
`


export default withAuthenticator(Manage);
  